import { render, staticRenderFns } from "./brokerDashboard.vue?vue&type=template&id=60bf1096&scoped=true"
import script from "./brokerDashboard.vue?vue&type=script&lang=js"
export * from "./brokerDashboard.vue?vue&type=script&lang=js"
import style0 from "./brokerDashboard.vue?vue&type=style&index=0&id=60bf1096&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bf1096",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60bf1096')) {
      api.createRecord('60bf1096', component.options)
    } else {
      api.reload('60bf1096', component.options)
    }
    module.hot.accept("./brokerDashboard.vue?vue&type=template&id=60bf1096&scoped=true", function () {
      api.rerender('60bf1096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/brokerDashboard.vue"
export default component.exports